import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
// Side-effect import: installs axios response interceptor that adds camelCase
// aliases to every API response so both PascalCase-readers (242 sites) and
// camelCase-readers (home page, etc.) see the data they expect.
import './services/controllersApi';
import './i18n';
import i18next from "i18next";
import { ContentLoading } from './components/contentLoading';
import CookieConsent from "react-cookie-consent";
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { register as registerServiceWorker } from './registerServiceWorker';
// import config, { setConfig } from "./configuration/config";
// import * as journify from "@journifyio/js-sdk";
// import Journify from "./services/journifyService";
const queryClient = new QueryClient();

function getLanguage() {
  const path = window.location.pathname.toLowerCase();
  if (path === '/en' || path.startsWith('/en/')) return 'en';
  if (path === '/ar' || path.startsWith('/ar/')) return 'ar';

  const lang = i18next.language ||
    (typeof window !== 'undefined' && window.localStorage.i18nextLng) ||
    'ar';

  return (lang !== 'ar' && lang !== 'en') ? 'ar' : lang;
}

const currentPath = window.location.pathname;
const detectedLang = getLanguage();

// Ensure i18next is in sync with the path
if (i18next.language !== detectedLang) {
  i18next.changeLanguage(detectedLang);
}

if (currentPath === '/' || currentPath === '') {
  // Default to Arabic if no language specified in URL
  window.location.replace('/ar/');
} else {
  const appElement = (
    <BrowserRouter basename={"/" + detectedLang}>
      <Suspense fallback={<ContentLoading />}>
        <React.StrictMode>
          <CookieConsent
            location="bottom"
            enableDeclineButton
            buttonText="قبول"
            declineButtonText="رفض"
            containerClasses="cookie-consent-container"
            buttonClasses="btn btn-primary text-24  py-5"
            declineButtonClasses="btn btn-danger text-24  py-5"
            contentClasses="cookie-content"
            buttonWrapperClasses='flex nice-flex-row-reverse nice-flex-wrap-content grid-2-cols'
            cookieName="myAppCookieConsent"
            customButtonWrapperAttributes={{ style: { flex: 'none', gap: "0rem" } }}
            contentStyle={{ flex: "auto", margin: "1rem" }}
            style={{ background: "#000000", color: "#FFFFFF", flexFlow: 'row-reverse', padding: "2rem", direction: "rtl", alignItems: "flex-start", bottom: "-1px", zIndex: 99999 }}
            buttonStyle={{ background: "#3bd461", color: "#000000", fontSize: "10px", borderRadius: "1rem", margin: "1rem" }}
            declineButtonStyle={{ order: 2, fontSize: "10px", borderRadius: "1rem", margin: "1rem" }}
            expires={350}
          >
            <p>
              <span className='text-16 text-white' style={{ fontSize: "12px" }}>
                بالنقر على "قبول"، فإنك توافق على استخدام ملفات تعريف الارتباط الخاصة بموقعنا على الويب وفقًا لما هو موضح في
              </span>
              <a className='text-16 text-primary' style={{ fontSize: "12px" }} target="_blank" rel="noreferrer" href='https://hassanjameel.com.sa/ar/websitePolicy'>
                سياسة ملفات تعريف الارتباط الخاصة بنا
              </a>
              <span className='text-16 text-white' style={{ fontSize: "12px" }}>
                . بخلاف ذلك، يمكنك الاعتراض على هذا الاستخدام بالنقر على "رفض". كما يمكنك تغيير إعدادات ملفات تعريف الارتباط الخاصة بك في أي وقت.
              </span>
            </p>
          </CookieConsent>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </React.StrictMode>
      </Suspense>
    </BrowserRouter>
  );

  const rootElement = document.getElementById('root');

  if (rootElement.hasChildNodes()) {
    ReactDOM.hydrate(appElement, rootElement);
  } else {
    ReactDOM.render(appElement, rootElement);
  }
}

reportWebVitals();
